import React from 'react';
import './DynaInput.scss';

const DynaTextarea = (props) => {

  const onChangeHandler = (e) => {
    const {name, value} = e.target;
    props.setDataFromComponent({[name]: value})
  }

  try {
    return (
      <div className={`main-dyna-input ${props.className !== undefined ? props.className : ""}`}
           style={props.style ? props.style : {}}>
        <label htmlFor={props.name}>{props.label}</label>
        <textarea
          id={props.id}
          className={`dyna-element ${props.classNameInput !== undefined ? props.classNameInput : ""}`}
          name={props.name}
          placeholder={props.placeholder}
          value={(props.value)}
          style={props.inlineStyles}
          disabled={props.disabled}
          onChange={(e) => onChangeHandler(e)}
        />
      </div>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default DynaTextarea;